import * as React from 'react';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import './index.css';
import './datepicker.css';

import { createRoot } from 'react-dom/client';
import Application from '@app/site/Application';
import { initializeSentry } from '@util/SentryHelper';
import useSiteState from '@app/state/SiteState';
import { registerUseTranslation } from '@ui/i18n/Translation';
import { useTranslation } from '@app/component/translation/Translation';

// The design-system Components read their texts through this seam, so register the app translations before the
// first render (ROO2-239).
registerUseTranslation(useTranslation);

// Initialize Sentry before anything else
if (process.env.NODE_ENV === 'production') {
	const { principal, token } = useSiteState.getState();
	initializeSentry(principal && token ? { id: String(principal.id), username: principal.username } : undefined);
}

if (process.env.NODE_ENV === 'production') {
	disableReactDevTools();
}
const container = document.getElementById('root');
if (!!container) {
	const root = createRoot(container);
	root.render(<Application />);
}
